/**
 * Inizializza grafici My Brain (Chart.js), calendario (FullCalendar),
 * widget task/progetti/pianificazione dentro HTML caricato via AJAX sulla dashboard v2.
 */
function loadCssOnce(href, marker) {
    if (document.querySelector(`link[data-${marker}="1"]`)) {
        return;
    }
    const l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = href;
    l.setAttribute(`data-${marker}`, '1');
    document.head.appendChild(l);
}

function loadScriptOnce(src, marker) {
    return new Promise((resolve, reject) => {
        if (document.querySelector(`script[data-${marker}="1"]`)) {
            resolve();
            return;
        }
        const s = document.createElement('script');
        s.src = src;
        s.async = true;
        s.setAttribute(`data-${marker}`, '1');
        s.onload = () => resolve();
        s.onerror = () => reject(new Error(`Load failed: ${src}`));
        document.head.appendChild(s);
    });
}

function parseJsonScript(el) {
    if (!el || !el.textContent) {
        return null;
    }
    try {
        return JSON.parse(el.textContent);
    } catch (e) {
        return null;
    }
}

function mountBarChart(canvasId, spec) {
    const canvas = document.getElementById(canvasId);
    if (!canvas || typeof window.Chart === 'undefined' || !spec || !spec.labels || !spec.data) {
        return;
    }
    if (canvas._mbChart) {
        canvas._mbChart.destroy();
    }
    const leaveData = Array.isArray(spec.leave_data) ? spec.leave_data : spec.labels.map(() => 0);
    const sicknessData = Array.isArray(spec.sickness_data) ? spec.sickness_data : spec.labels.map(() => 0);
    const ctx = canvas.getContext('2d');
    canvas._mbChart = new window.Chart(ctx, {
        type: 'bar',
        data: {
            labels: spec.labels,
            datasets: [
                {
                    label: 'Ore rendicontate',
                    data: spec.data,
                    backgroundColor: 'rgba(54, 162, 235, 0.7)',
                    borderColor: 'rgba(54, 162, 235, 0.7)',
                    borderWidth: 0,
                    borderRadius: 4,
                    barPercentage: 0.5,
                    categoryPercentage: 0.8,
                    stack: 'hours',
                },
                {
                    label: 'Ferie / permessi',
                    data: leaveData,
                    backgroundColor: 'rgba(0, 166, 90, 0.75)',
                    borderColor: 'rgba(0, 166, 90, 0.75)',
                    borderWidth: 0,
                    borderRadius: 4,
                    barPercentage: 0.5,
                    categoryPercentage: 0.8,
                    stack: 'hours',
                },
                {
                    label: 'Malattia',
                    data: sicknessData,
                    backgroundColor: 'rgba(243, 156, 18, 0.8)',
                    borderColor: 'rgba(243, 156, 18, 0.8)',
                    borderWidth: 0,
                    borderRadius: 4,
                    barPercentage: 0.5,
                    categoryPercentage: 0.8,
                    stack: 'hours',
                },
            ],
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                y: { beginAtZero: true, stacked: true },
                x: { stacked: true, grid: { display: false } },
            },
            plugins: { legend: { position: 'bottom' } },
        },
    });
}

function mountPieChart(canvasId, spec) {
    const canvas = document.getElementById(canvasId);
    if (!canvas || typeof window.Chart === 'undefined' || !spec || !spec.labels || !spec.data) {
        return;
    }
    if (canvas._mbChart) {
        canvas._mbChart.destroy();
    }
    const n = spec.data.length;
    let colors = spec.colors && spec.colors.length ? spec.colors.slice() : [];
    while (colors.length < n) {
        colors.push(['#3c8dbc', '#00a65a', '#f39c12', '#dd4b39', '#9b59b6', '#3498db', '#e67e22', '#95a5a6'][colors.length % 8]);
    }
    const ctx = canvas.getContext('2d');
    canvas._mbChart = new window.Chart(ctx, {
        type: 'pie',
        data: {
            labels: spec.labels,
            datasets: [{
                data: spec.data,
                backgroundColor: colors,
                borderWidth: 0,
            }],
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: { legend: { display: true, position: 'right' } },
        },
    });
}

function mountFullCalendar(rootEl) {
    const scriptEl = rootEl.querySelector('script[data-mybrain-fc-id]');
    const calId = scriptEl && scriptEl.getAttribute('data-mybrain-fc-id');
    const calEl = calId ? document.getElementById(calId) : null;
    if (!scriptEl || !calEl || typeof window.FullCalendar === 'undefined') {
        return;
    }
    const events = parseJsonScript(scriptEl) || [];
    if (calEl._mbFc) {
        calEl._mbFc.destroy();
        calEl._mbFc = null;
    }
    calEl._mbFc = new window.FullCalendar.Calendar(calEl, {
        initialView: 'dayGridMonth',
        locale: 'it',
        headerToolbar: { left: 'prev,next', center: 'title', right: 'today prevYear,nextYear' },
        buttonIcons: false,
        buttonText: {
            today: 'Oggi',
            month: 'Mese',
            week: 'Settimana',
            day: 'Giorno',
            list: 'Lista',
            prev: '\u2039',
            next: '\u203A',
        },
        customButtons: {
            prevYear: { text: '\u00AB Anno', click() { calEl._mbFc.prevYear(); } },
            nextYear: { text: 'Anno \u00BB', click() { calEl._mbFc.nextYear(); } },
        },
        events,
        firstDay: 1,
        height: 'auto',
    });
    calEl._mbFc.render();
}

// ----- Sidebar Vue condivisa (dashboard v2) -----
function ensureTaskSidebarVueDashboard() {
    if (typeof window.Vue === 'undefined') {
        return null;
    }
    if (window.savedVueInstance_dashboard_v2) {
        return window.savedVueInstance_dashboard_v2;
    }
    const host = document.getElementById('taskSidebarApp_dashboard_v2');
    const template = document.getElementById('taskSidebarTemplate_dashboard_v2');
    if (!host || !template) {
        return null;
    }
    if (host.__vue__) {
        window.savedVueInstance_dashboard_v2 = host.__vue__;
        return host.__vue__;
    }
    try {
        const instance = new window.Vue({
            el: '#taskSidebarApp_dashboard_v2',
            template: '#taskSidebarTemplate_dashboard_v2',
            data: { selectedTaskId: null, currentProjectId: null, canModify: true },
            methods: {
                openSidebar(taskId, projectId) {
                    if (this.selectedTaskId === taskId) {
                        if (this.$refs.taskSidebar && this.$refs.taskSidebar.isOpen) return;
                        if (this.$refs.taskSidebar) this.$refs.taskSidebar.open();
                        return;
                    }
                    this.currentProjectId = projectId;
                    this.selectedTaskId = taskId;
                },
                closeSidebar() {
                    this.selectedTaskId = null;
                    this.currentProjectId = null;
                },
            },
        });
        window.savedVueInstance_dashboard_v2 = instance;
        return instance;
    } catch (e) {
        console.error('Impossibile montare sidebar Vue dashboard v2', e);
        return null;
    }
}

// ----- Select2 filtro progetti (etichetta con azienda + autocomplete) -----
function formatMyBrainProjectFilterOption(option) {
    if (!option.id) {
        return option.text;
    }
    const $el = window.$(option.element);
    const title = $el.data('project-title') || option.text;
    const suffix = $el.data('filter-suffix');
    if (suffix) {
        return window.$('<span>' + window.$('<span>').text(title).html() +
            ' <span style="color: #999; font-size: 11px;">- ' + window.$('<span>').text(suffix).html() + '</span></span>');
    }

    return window.$('<span>').text(title).html();
}

function initMyBrainProjectFilterSelect(rootEl, onFilterChange) {
    if (!window.$) {
        return;
    }
    const scope = rootEl && rootEl.querySelectorAll ? rootEl : document;
    scope.querySelectorAll('.mb-project-filter-select').forEach((select) => {
        const $select = window.$(select);
        if ($select.data('select2')) {
            if (typeof onFilterChange === 'function') {
                $select.off('change.mbProjectFilter select2:select.mbProjectFilter select2:clear.mbProjectFilter');
                $select.on('change.mbProjectFilter select2:select.mbProjectFilter select2:clear.mbProjectFilter', onFilterChange);
            }
            return;
        }
        $select.select2({
            width: 'resolve',
            dropdownAutoWidth: true,
            dropdownCssClass: 'mb-project-filter-dropdown',
            placeholder: 'Tutti i progetti',
            allowClear: true,
            templateResult: formatMyBrainProjectFilterOption,
            templateSelection: formatMyBrainProjectFilterOption,
        });
        if (typeof onFilterChange === 'function') {
            $select.on('change.mbProjectFilter select2:select.mbProjectFilter select2:clear.mbProjectFilter', onFilterChange);
        }
    });
}

function clearMyBrainProjectFilterSelect(select) {
    if (!select) {
        return;
    }
    if (window.$ && window.$(select).data('select2')) {
        window.$(select).val(null).trigger('change');
        return;
    }
    select.value = '';
}

// ----- Widget "Le mie attività" (filtri + sort + complete + sidebar) -----
function mountTasksWidget(rootEl) {
    rootEl.querySelectorAll('[data-mb-tasks-widget="1"]').forEach((widget) => {
        if (widget._mbTasksBound) return;
        widget._mbTasksBound = true;

        const table = widget.querySelector('.mb-tasks-table');
        if (!table) return;
        const tbody = table.querySelector('tbody');
        const countEl = widget.querySelector('.mb-tasks-count');

        const filterName = widget.querySelector('.mb-filter-name');
        const filterProject = widget.querySelector('.mb-filter-project');
        const filterPriority = widget.querySelector('.mb-filter-priority');
        const filterStatus = widget.querySelector('.mb-filter-status');
        const resetBtn = widget.querySelector('.mb-filter-reset');

        initMyBrainProjectFilterSelect(widget, applyFilters);

        let currentSort = { column: null, direction: 'asc' };

        function applyFilters() {
            const nameVal = (filterName && filterName.value || '').toLowerCase();
            const projectVal = filterProject
                ? (window.$ && window.$(filterProject).data('select2')
                    ? String(window.$(filterProject).val() || '')
                    : String(filterProject.value || ''))
                : '';
            const priorityVal = filterPriority && filterPriority.value || '';
            const statusVal = filterStatus && filterStatus.value || '';

            let visibleCount = 0;
            tbody.querySelectorAll('tr').forEach((row) => {
                const taskName = (row.getAttribute('data-task-name') || '');
                const projectId = String(row.getAttribute('data-project-id') || '');
                const priority = row.getAttribute('data-priority') || '';
                const status = row.getAttribute('data-status') || '';

                let visible = true;
                if (nameVal && !taskName.includes(nameVal)) visible = false;
                if (projectVal && projectId !== String(projectVal)) visible = false;
                if (priorityVal && priority !== priorityVal) visible = false;
                if (statusVal && status !== statusVal) visible = false;

                row.style.display = visible ? '' : 'none';
                if (visible) visibleCount++;
            });

            if (countEl) {
                countEl.textContent = visibleCount + ' attività';
            }
            applySorting();
        }

        function applySorting() {
            if (!currentSort.column) return;
            const rows = Array.from(tbody.querySelectorAll('tr')).filter((r) => r.style.display !== 'none');
            const priorityMap = { high: 3, medium: 2, low: 1 };
            const statusMap = { todo: 1, in_progress: 2, done: 3 };

            rows.sort((a, b) => {
                let av, bv;
                switch (currentSort.column) {
                    case 'name':
                        av = a.getAttribute('data-task-name') || '';
                        bv = b.getAttribute('data-task-name') || '';
                        break;
                    case 'project':
                        av = a.getAttribute('data-project-name') || '';
                        bv = b.getAttribute('data-project-name') || '';
                        break;
                    case 'client':
                        av = a.getAttribute('data-client-name') || '';
                        bv = b.getAttribute('data-client-name') || '';
                        break;
                    case 'priority':
                        av = priorityMap[a.getAttribute('data-priority')] || 0;
                        bv = priorityMap[b.getAttribute('data-priority')] || 0;
                        break;
                    case 'status':
                        av = statusMap[a.getAttribute('data-status')] || 0;
                        bv = statusMap[b.getAttribute('data-status')] || 0;
                        break;
                    case 'due_date':
                        av = a.getAttribute('data-due-date') || '9999-12-31';
                        bv = b.getAttribute('data-due-date') || '9999-12-31';
                        break;
                    default:
                        return 0;
                }
                if (av < bv) return currentSort.direction === 'asc' ? -1 : 1;
                if (av > bv) return currentSort.direction === 'asc' ? 1 : -1;
                return 0;
            });

            rows.forEach((r) => tbody.appendChild(r));
        }

        widget._mbApplyFilters = applyFilters;

        widget.querySelectorAll('.mb-sortable').forEach((th) => {
            th.addEventListener('click', () => {
                const col = th.getAttribute('data-sort');
                widget.querySelectorAll('.mb-sortable').forEach((o) => o.classList.remove('sort-asc', 'sort-desc'));
                if (currentSort.column === col) {
                    currentSort.direction = currentSort.direction === 'asc' ? 'desc' : 'asc';
                } else {
                    currentSort.column = col;
                    currentSort.direction = 'asc';
                }
                th.classList.add('sort-' + currentSort.direction);
                applySorting();
            });
        });

        ['input', 'change'].forEach((evt) => {
            [filterName, filterPriority, filterStatus].forEach((el) => {
                if (el) el.addEventListener(evt, applyFilters);
            });
        });
        if (resetBtn) {
            resetBtn.addEventListener('click', () => {
                if (filterName) filterName.value = '';
                if (filterPriority) filterPriority.value = '';
                if (filterStatus) filterStatus.value = '';
                clearMyBrainProjectFilterSelect(filterProject);
                currentSort = { column: null, direction: 'asc' };
                widget.querySelectorAll('.mb-sortable').forEach((o) => o.classList.remove('sort-asc', 'sort-desc'));
                applyFilters();
            });
        }

        widget.addEventListener('click', (e) => {
            const openBtn = e.target.closest('.mb-open-task');
            if (openBtn) {
                e.preventDefault();
                const taskId = parseInt(openBtn.getAttribute('data-task-id'), 10);
                const projectId = parseInt(openBtn.getAttribute('data-project-id'), 10);
                const instance = ensureTaskSidebarVueDashboard();
                if (instance) {
                    instance.openSidebar(taskId, projectId);
                } else {
                    console.error('Sidebar Vue non disponibile');
                }
                return;
            }

            const completeBtn = e.target.closest('.mb-complete-task');
            if (completeBtn) {
                e.preventDefault();
                const taskId = completeBtn.getAttribute('data-task-id');
                const row = completeBtn.closest('tr');
                const isArchived = completeBtn.classList.contains('archived');
                const newArchived = isArchived ? 0 : 1;
                const cfg = window.DashboardV2Config || {};
                const token = cfg.csrfToken || '';
                completeBtn.disabled = true;
                const url = '/admin/subprojects/grid/' + taskId;
                fetch(url, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': token,
                        'Accept': 'application/json',
                    },
                    credentials: 'same-origin',
                    body: JSON.stringify({ archived: newArchived, _token: token }),
                })
                    .then((r) => r.json().catch(() => ({})))
                    .then((res) => {
                        if (res && res.success !== false) {
                            if (newArchived) {
                                completeBtn.classList.add('archived');
                                if (row) row.classList.add('archived');
                                completeBtn.setAttribute('title', 'Riapri attività');
                            } else {
                                completeBtn.classList.remove('archived');
                                if (row) row.classList.remove('archived');
                                completeBtn.setAttribute('title', 'Segna come completata');
                            }
                        } else if (window.Swal) {
                            window.Swal.fire({ icon: 'error', title: 'Errore', text: (res && res.message) || 'Errore aggiornamento task' });
                        }
                    })
                    .catch((err) => {
                        console.error('Errore complete task widget', err);
                        if (window.Swal) window.Swal.fire({ icon: 'error', title: 'Errore', text: 'Errore aggiornamento task' });
                    })
                    .finally(() => { completeBtn.disabled = false; });
            }
        });

        applyFilters();
    });
}

// ----- Widget progetti cliccabili (filtra tabella task sibling) -----
function mountProjectsWidget(rootEl) {
    rootEl.querySelectorAll('[data-mb-projects-widget="1"]').forEach((widget) => {
        if (widget._mbProjectsBound) return;
        widget._mbProjectsBound = true;

        widget.addEventListener('dblclick', (e) => {
            const card = e.target.closest('.mb-project-card');
            if (!card) return;
            const url = card.getAttribute('data-project-url');
            if (url) window.location.href = url;
        });

        widget.addEventListener('click', (e) => {
            const card = e.target.closest('.mb-project-card');
            if (!card) return;
            const projectId = card.getAttribute('data-project-id');

            const tasksWidget = document.querySelector('[data-mb-tasks-widget="1"]');
            if (tasksWidget) {
                widget.querySelectorAll('.mb-project-card.mb-active').forEach((el) => {
                    if (el !== card) el.classList.remove('mb-active');
                });
                const wasActive = card.classList.toggle('mb-active');
                const select = tasksWidget.querySelector('.mb-filter-project');
                if (select) {
                    const val = wasActive ? String(projectId) : '';
                    if (window.$ && window.$(select).data('select2')) {
                        window.$(select).val(val || null).trigger('change');
                    } else {
                        select.value = val;
                        if (typeof tasksWidget._mbApplyFilters === 'function') {
                            tasksWidget._mbApplyFilters();
                        } else {
                            select.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                    }
                }
                tasksWidget.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } else {
                const url = card.getAttribute('data-project-url');
                if (url) window.location.href = url;
            }
        });
    });
}

// ----- Widget pianificazione (embed Vue <developers-planning>) -----
function mountPlanningWidget(rootEl) {
    if (typeof window.Vue === 'undefined') return;
    rootEl.querySelectorAll('[data-mb-planning-widget="1"]').forEach((widget) => {
        if (widget._mbPlanningBound) return;
        const mountEl = widget.querySelector('.mb-planning-mount');
        if (!mountEl) return;
        widget._mbPlanningBound = true;
        try {
            new window.Vue({ el: mountEl });
        } catch (e) {
            console.error('Impossibile montare developers-planning nel widget', e);
        }
    });
}

export function mountDashboardMyBrainIn(rootEl) {
    if (!rootEl || !rootEl.querySelectorAll) {
        return;
    }
    rootEl.querySelectorAll('script[data-mybrain-chart-spec]').forEach((script) => {
        const specType = script.getAttribute('data-mybrain-chart-spec');
        const canvasId = script.getAttribute('data-canvas-id');
        const spec = parseJsonScript(script);
        if (!canvasId || !spec) {
            return;
        }
        if (specType === 'bar') {
            mountBarChart(canvasId, spec);
        } else if (specType === 'pie') {
            mountPieChart(canvasId, spec);
        }
    });

    if (rootEl.querySelector('[data-mybrain-fc-calendar]')) {
        // Il CSS di FullCalendar è caricato da home-v2.blade.php via @push('styles');
        // qui carichiamo solo il JS e poi renderizziamo.
        loadCssOnce('https://cdn.jsdelivr.net/npm/fullcalendar@5.11.3/main.min.css', 'mybrain-fc-css');
        loadScriptOnce('https://cdn.jsdelivr.net/npm/fullcalendar@5.11.3/main.min.js', 'mybrain-fc-js')
            .then(() => loadScriptOnce('https://cdn.jsdelivr.net/npm/fullcalendar@5.11.3/locales-all.min.js', 'mybrain-fc-locales'))
            .then(() => mountFullCalendar(rootEl))
            .catch(() => {});
    }

    mountTasksWidget(rootEl);
    mountProjectsWidget(rootEl);
    mountPlanningWidget(rootEl);
    mountTaskInbox(rootEl);
}

function mountTaskInbox(rootEl) {
    rootEl.querySelectorAll('[data-mb-task-inbox]').forEach((box) => {
        if (box._mbInboxBound) {
            return;
        }
        box._mbInboxBound = true;
        box.addEventListener('click', (event) => {
            const button = event.target.closest('[data-inbox-action]');
            if (!button) {
                return;
            }
            const token = document.querySelector('meta[name="csrf-token"]');
            const action = button.getAttribute('data-inbox-action');
            const id = button.getAttribute('data-id');
            const taskId = button.getAttribute('data-task-id');
            const url = action === 'read-task'
                ? '/my-brain/task-inbox/task/' + taskId + '/read'
                : '/my-brain/task-inbox/' + id + '/' + action;
            fetch(url, {
                method: 'POST',
                headers: {
                    'X-CSRF-TOKEN': token ? token.content : '',
                    'Accept': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                },
            }).then((response) => {
                if (!response.ok) {
                    return;
                }
                if (action === 'archive') {
                    const row = button.closest('[data-inbox-item]');
                    if (row) {
                        row.remove();
                    }
                }
                if (action === 'read-task') {
                    const group = button.closest('.mb-inbox-group');
                    if (group) {
                        group.querySelectorAll('[data-inbox-item]').forEach((row) => {
                            row.style.opacity = '0.65';
                        });
                        button.remove();
                    }
                }
            }).catch(() => {});
        });
    });
}

window.mountDashboardMyBrainIn = mountDashboardMyBrainIn;
window.initMyBrainProjectFilterSelect = initMyBrainProjectFilterSelect;
window.clearMyBrainProjectFilterSelect = clearMyBrainProjectFilterSelect;

if (typeof document !== 'undefined') {
    document.addEventListener('DOMContentLoaded', () => {
        setTimeout(() => {
            ensureTaskSidebarVueDashboard();
        }, 300);
    });
}
